(function () {
  'use strict';
  // Custom-event publisher only. A separately verified receiver is required for GA4.
  if (window.PrepareHQMeasurementV1929) return;
  window.PrepareHQMeasurementV1929 = true;
  var prefix = 'preparehq.measurement.pending.v1.';
  var ttl = 30 * 60 * 1000;
  var entryKey = 'preparehq.measurement.entry.v1';
  var forms = { PrepareHQReserveEnquiryV1714: 'food_enquiry', PrepareHQContact: 'contact', PrepareHQLargeOrder: 'large_order' };
  var ready = false;
  var lastFinder = '', lastFinderAt = 0;

  function allowed() {
    try {
      return window.Shopify.customerPrivacy.analyticsProcessingAllowed() === true;
    } catch (error) { return false; }
  }
  function explicitlyDenied() {
    try {
      return window.Shopify.customerPrivacy.currentVisitorConsent().analytics === 'no';
    } catch (error) { return false; }
  }
  function remove(id) {
    try { window.sessionStorage.removeItem(prefix + id); } catch (error) { /* Fail closed. */ }
  }
  function publish(name, data) {
    if (!allowed()) return;
    try {
      var entry = entryContext();
      data.first_measured_page = entry.page;
      data.first_measured_source = entry.source;
      var result = window.Shopify.analytics.publish(name, data);
      if (result && typeof result.catch === 'function') result.catch(function () {});
    } catch (error) { /* Measurement must never interrupt shopping or contact forms. */ }
  }
  function integer(value, min, max) {
    return Number.isInteger(value) && value >= min && value <= max;
  }
  function pageGroup(path) {
    if (path === '/') return 'home';
    if (path === '/blogs/advice/food-to-store-for-power-cut') return 'power_cut_guide';
    if (path === '/collections/6-tin-food-boxes') return 'builder';
    if (path === '/collections/family-emergency-food-supplies') return 'family_food';
    if (path === '/pages/contact') return 'contact';
    if (path.indexOf('/blogs/') === 0) return 'other_article';
    if (path.indexOf('/products/') === 0) return 'product';
    if (path.indexOf('/collections/') === 0) return 'other_collection';
    return 'other_page';
  }
  function entryContext() {
    var pages = ['home', 'power_cut_guide', 'builder', 'family_food', 'contact', 'other_article', 'product', 'other_collection', 'other_page'];
    var sources = ['paid_tag_present', 'tagged_campaign', 'google_referral', 'bing_referral', 'external_referral', 'direct_or_unknown', 'internal_or_unknown'];
    var saved;
    try {
      saved = JSON.parse(window.sessionStorage.getItem(entryKey));
      if (!saved || pages.indexOf(saved.page) < 0 || sources.indexOf(saved.source) < 0 ||
          !Number.isFinite(saved.expires) || saved.expires <= Date.now() || saved.expires > Date.now() + ttl) saved = null;
    } catch (error) { saved = null; }
    if (!saved) {
      var source = 'direct_or_unknown';
      var url = new URL(window.location.href);
      // Only fixed categories survive; never store full URLs, search terms or identifiers.
      if (['gclid', 'gbraid', 'wbraid', 'msclkid'].some(function (key) { return url.searchParams.has(key); })) source = 'paid_tag_present';
      else if (url.searchParams.has('utm_source') || url.searchParams.has('utm_medium')) source = 'tagged_campaign';
      else if (document.referrer) {
        try {
          var host = new URL(document.referrer).hostname;
          if (host === window.location.hostname) source = 'internal_or_unknown';
          else if (host === 'com.google.android.googlequicksearchbox' || /^(www\.)?google\.(com|co\.uk|ie|fr|de|es|it|nl|be|ca|com\.au|co\.nz)$/.test(host)) source = 'google_referral';
          else if (/^(www\.)?bing\.com$/.test(host)) source = 'bing_referral';
          else source = 'external_referral';
        } catch (error) { /* Keep unknown. */ }
      }
      saved = { page: pageGroup(window.location.pathname), source: source };
    }
    saved.expires = Date.now() + ttl;
    try { window.sessionStorage.setItem(entryKey, JSON.stringify(saved)); } catch (error) { /* Current-page context only. */ }
    return saved;
  }
  document.addEventListener('phq:finder-completed', function (event) {
    if (!allowed() || !event.target || !event.target.matches('[data-phq-shopping]')) return;
    var detail = event.detail || {}, request = detail.request || {}, result = detail.recommendation || {};
    if (result.valid !== true || !integer(request.people, 1, 8) || [1, 3, 6, 12].indexOf(request.months) < 0 ||
        ['main', 'bm', 'bmp', 'b2mp'].indexOf(request.pattern) < 0 || ['mixed', 'vegetarian'].indexOf(request.diet) < 0 ||
        !integer(result.cases, 1, 999999) || !integer(result.pricePence, 0, 999999999)) return;
    var fingerprint = [request.people, request.months, request.pattern, request.diet, result.cases, result.pricePence].join(':');
    if (lastFinder === fingerprint && Date.now() - lastFinderAt < 2000) return;
    lastFinder = fingerprint;
    lastFinderAt = Date.now();
    // Construct an allowlist: never forward the recommendation, basket, URL or form values.
    publish('phq_finder_results', {
      schema_version: 1,
      people: request.people,
      months: request.months,
      meal_pattern: request.pattern,
      diet: request.diet,
      case_count: result.cases,
      food_value_band: result.pricePence < 200000 ? 'under_2000' : '2000_or_more'
    });
  });

  // Shopify hCaptcha prevents the ordinary submit, then calls native form.submit().
  // Record a valid attempt before that interception; only a later server success can count.
  // No field values are read and no validation or spam-protection handler is changed.
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !Object.prototype.hasOwnProperty.call(forms, form.id)) return;
    remove(form.id);
    if (!allowed() || !form.checkValidity()) return;
    try {
      window.sessionStorage.setItem(prefix + form.id, JSON.stringify({
        version: 1, path: window.location.pathname, expires: Date.now() + ttl
      }));
    } catch (error) { /* No cross-page deduplication means no lead event. */ }
  }, true);

  function freshNavigation() {
    try {
      var navigation = window.performance.getEntriesByType('navigation')[0];
      return navigation && navigation.type === 'navigate';
    } catch (error) { return false; }
  }
  function checkSuccess(event) {
    if (!ready) return;
    if (!allowed()) {
      // A not-yet-initialised consent API is not an explicit withdrawal.
      if (explicitlyDenied()) {
        Object.keys(forms).forEach(remove);
        try { window.sessionStorage.removeItem(entryKey); } catch (error) { /* Fail closed. */ }
      }
      return;
    }
    // An abandoned attempt must not match an older success page restored from history.
    if ((event && event.persisted) || !freshNavigation()) {
      Object.keys(forms).forEach(remove);
      return;
    }
    entryContext();
    document.querySelectorAll('form').forEach(function (form) {
      if (!Object.prototype.hasOwnProperty.call(forms, form.id)) return;
      var success = form.querySelector('[data-phq-enquiry-state="success"], [data-phq-shopping-confirmation], [data-phq-v1711-form-success]');
      var pending = null;
      try {
        var raw = window.sessionStorage.getItem(prefix + form.id);
        if (raw && raw.length < 1024) pending = JSON.parse(raw);
        // Consume before publishing. Refresh, pageshow and duplicate script loads cannot replay it.
        window.sessionStorage.removeItem(prefix + form.id);
      } catch (error) { remove(form.id); return; }
      if (!success || !pending || pending.version !== 1 || pending.path !== window.location.pathname ||
          !Number.isFinite(pending.expires) || pending.expires <= Date.now() || pending.expires > Date.now() + ttl) return;
      publish('phq_enquiry_success', { schema_version: 1, form_type: forms[form.id] });
    });
  }
  function boot() {
    var shop = window.Shopify;
    if (!shop || shop.designMode) return;
    if (shop.customerPrivacy) { ready = true; checkSuccess(); return; }
    if (typeof shop.loadFeatures !== 'function') return;
    try {
      shop.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
        if (error) return;
        ready = true;
        checkSuccess();
      });
    } catch (error) { /* Missing privacy API disables measurement. */ }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('pageshow', checkSuccess);
  window.addEventListener('load', checkSuccess);
  document.addEventListener('visitorConsentCollected', checkSuccess);
}());
